import React, { useState, useRef, useEffect } from "react";
import DataTable from "react-data-table-component";
import { sportEndPoint } from "../../../constant/Environment";
import { getAllReport } from "../../../Utility/API";
import LiveBetSearch from "../../../components/FilterComponent/LiveBetSearch.js";
import Loader from "../../../components/Loader";


function getNumberOfPages(rowCount, rowsPerPage) {
  return Math.ceil(rowCount / rowsPerPage);
}

function toPages(pages) {
  const results = [];
  for (let i = 1; i <= pages; i++) {
    results.push(i);
  }

  return results;
}

const columns = [
  {
    name: "Bet Sales",
    selector: (row) => row.Bet_Sales,
    sortable: true,
  },
  {
    name: "Bets Cancelled",
    selector: (row) => row.Bets_Cancelled,
    sortable: true,
  },
  {
    name: "Bets Paid",
    selector: (row) => row.Bets_Paid,
    sortable: true,
  },
  {
    name: "Bets Voided",
    selector: (row) => row.Bets_Voided,
    sortable: true,
  },
  {
    name: "Event Type",
    selector: (row) => row.Event_Type,
    sortable: true,
  },
  {
    name: "Gaming Date",
    selector: (row) => row.Gaming_Date,
    sortable: true,
  },
  {
    name: "Gross Revenue",
    selector: (row) => row.Gross_Revenue,
    sortable: true,
  },
  {
    name: "Resettled Bet Adjustment",
    selector: (row) => row.Resettled_Bet_Adjustment,
    sortable: true,
  }
  
];
 // RDT exposes the following internal pagination properties
 const BootyPagination = ({
  rowsPerPage,
  rowCount,
  onChangePage,
  onChangeRowsPerPage, // available but not used here
  currentPage
}) => {
  const handleBackButtonClick = () => {
    onChangePage(currentPage - 1);
  };

  const handleNextButtonClick = () => {
    onChangePage(currentPage + 1);
  };

  const handlePageNumber = (e) => {
    onChangePage(Number(e.target.value));
  };

  const pages = getNumberOfPages(rowCount, rowsPerPage);
  const pageItems = toPages(pages);
  const nextDisabled = currentPage === pageItems.length;
  const previosDisabled = currentPage === 1;

  return (
    <nav>
      <ul className="pagination">
        <li className="page-item">
          <button
            className="page-link"
            onClick={handleBackButtonClick}
            disabled={previosDisabled}
            aria-disabled={previosDisabled}
            aria-label="previous page"
          >
            Previous
          </button>
        </li>
        {pageItems.map((page) => {
          
          const className =
            page === currentPage ? "page-item active" : "page-item";

          return (
            <li key={page} className={className}>
              <button
                className="page-link"
                onClick={handlePageNumber}
                value={page}
              >
                {page}
              </button>
            </li>
          );
        })}
        <li className="page-item">
          <button
            className="page-link"
            onClick={handleNextButtonClick}
            disabled={nextDisabled}
            aria-disabled={nextDisabled}
            aria-label="next page"
          >
            Next
          </button>
        </li>
      </ul>
    </nav>
  );
};

const ResultsSummary = () => {
  const [pending, setPending] = useState(true);
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoadinig] = useState(false);
  const [filterText] = React.useState("");
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);



  useEffect(() => {
    fetchUserData();
  }, []);

  const fetchUserData = async () => {
   
    let url = `${sportEndPoint.apiBaseUrl+sportEndPoint.api.LIVE_BET_SUMMARY}`;
    var body = {
      type: "LIST",
      period: "3m"
  }
      await getAllReport(url,body)
      .then((response) => {
        console.log("data", response);
        if (response) {
          setRows(response);
          setPending(false);
        } else {
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  return (
    <>
      <div className="main">
      
        {isLoading && <Loader spinner={true} visible={isLoading} />}
        <div id="Sportbook" style={{padding:'0px'}}>
          <div className="container-fluid bg-color-sportbook custom-card4">
            <div className="inner-space1">
              <div className="row">
                <div className="col-md-12">
                  <h2 className="mb-2">Results Summary</h2>
                </div>
              </div>
              <div
                className="row"
                style={{ padding: "5px 0px 20px 0px" }}
              >
                 <div className="col-md-12">
                <LiveBetSearch  report="" reporturl={sportEndPoint.apiBaseUrl+sportEndPoint.api.LIVE_BET_SUMMARY}/>
                </div>

                </div>
                <div className="container-fluid table-custom">
              <div
                className="row"
                style={{  padding: "5px 0px 20px 0px" }}
              >
               
               <div className="col-md-12">
                <DataTable
          title=""
          columns={columns}
          data={rows}
          defaultSortFieldID={1}
          pagination
          paginationComponent={BootyPagination}
          paginationResetDefaultPage={resetPaginationToggle} // optionally, a hook to reset pagination to page 1
          // subHeader
          // subHeaderComponent={subHeaderComponentMemo}
        />

               </div>
               </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ResultsSummary;
